import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSkinTimePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionSkinTime.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionSkinTime.button1'),
          value: 'less_than_5',
        },
        {
          text: t('pages.onboarding.questionSkinTime.button2'),
          value: '5-10_minutes',
        },
        {
          text: t('pages.onboarding.questionSkinTime.button3'),
          value: 'whatever_it_takes',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
